import { useId } from 'react';
import ConditionalWrapper from '../ConditionalWrapper';
import { SCard } from '../s-polaris';

const CHOICE_VALUE = 'selected';

const SelectionCard: React.FC<SelectionCardProps> = (props) => {
    const id = useId();

    return (
        <ConditionalWrapper
            condition={!!props.tooltip?.length}
            wrapper={(c) => (
                <div className="grid relative">
                    <s-clickable
                        disabled={props?.disabled}
                        interestFor={id}
                        blockSize="100%"
                        inlineSize="100%"
                        background="transparent"
                    >
                        <div className="h-full grid">{c}</div>
                    </s-clickable>
                    <s-tooltip id={id}>{props.tooltip}</s-tooltip>
                </div>
            )}
        >
            <SCard padding="0">
                <div
                    className="selection-card flex items-center gap-2"
                    data-selected={props.selected ? '' : undefined}
                    data-disabled={props.disabled ? '' : undefined}
                    onClick={props.disabled ? undefined : props.onClick}
                >
                    {/*
                     * A Polaris radio only exists as `s-choice` inside an `s-choice-list`, so each card
                     * hosts its own single-choice list purely as the selection indicator. Pointer events
                     * go through to the card's own click handler; keyboard selection on the radio is
                     * forwarded via `onChange`.
                     */}
                    <div className="shrink-0 pointer-events-none">
                        <s-choice-list
                            name={id}
                            label={props.label}
                            labelAccessibilityVisibility="exclusive"
                            values={props.selected ? [CHOICE_VALUE] : []}
                            disabled={props.disabled}
                            onChange={() => !props.disabled && props.onClick()}
                        >
                            <s-choice value={CHOICE_VALUE} accessibilityLabel={props.label} />
                        </s-choice-list>
                    </div>
                    <div className="flex-1 min-w-0 self-stretch grid">{props.children}</div>
                </div>
            </SCard>
        </ConditionalWrapper>
    );
};

export default SelectionCard;

interface SelectionCardProps {
    selected: boolean;
    onClick(): void;
    /** Accessible name for the card's radio indicator (visually hidden). */
    label: string;
    children: React.ReactElement;
    disabled?: boolean;
    tooltip?: string;
}
